import { inject } from "../../../../../../lib/itn-ui-kit/services/service-container";

export function useOperationHoursPermissions() {
  const currentUserService = inject("current-user-service");
  const permissions = currentUserService?.userRoles?.permissions ?? [];

  const canDeleteHoursOfOperation = permissions.includes("provider.delete_providerofficehours");
  const canViewHoursOfOperation = permissions.includes("provider.view_providerofficehours");
  const canAddHoursOfOperation = permissions.includes("provider.add_providerofficehours");
  const canEditHoursOfOperation = permissions.includes("provider.change_providerofficehours");

  return {
    canDeleteHoursOfOperation,
    canViewHoursOfOperation,
    canAddHoursOfOperation,
    canEditHoursOfOperation,
  };
}
